import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { hmsAdvantages } from "../hmsModulesData";
import HmsIcon from "../hmsIcons";

const HmsAdvantagesSection: React.FC = () => {
  return (
    <section className="hms-stats" aria-labelledby="hms-advantages-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="hms-advantages-title"
            className="wdev-section-head__title wdev-section-head__title--dark"
          >
            Seamless &amp; Cutting-Edge Advantages
          </h2>
          <p className="hms-stats__lead">
            Some of the seamless and cutting-edge advantages catered by our automated hospital
            management system.
          </p>
        </AnimatedSection>

        <ul className="hms-stats__list">
          {hmsAdvantages.map((advantage, index) => (
            <motion.li
              key={advantage.text}
              className="hms-stats__item"
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
            >
              <span className="hms-stats__icon">
                <HmsIcon name={advantage.icon} />
              </span>
              <p>{advantage.text}</p>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HmsAdvantagesSection;
